/*
 * GOAIWA - keyboard support for header menus when "Open dropdown items on" is set to Hover.
 *
 * In hover mode Impact cancels every click on a menu <summary> (it only follows the optional
 * parent link), so Enter / Space could never open a mega menu. Keyboard-generated clicks
 * (event.detail === 0) are intercepted here and toggle the disclosure through Impact's own
 * "open" setter, which keeps its animations, Escape-to-close and focus-out handling intact.
 * Mouse and touch clicks are untouched.
 */
document.addEventListener('click', (event) => {
  if (event.detail !== 0) {
    return;
  }

  const summary = event.target.closest('.header__link-list details > summary');

  if (!summary) {
    return;
  }

  const details = summary.parentElement;

  // "trigger" is Impact's getter: it already returns "click" on touch devices
  if (details.trigger !== 'hover') {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  details.open = !details.open;
}, true);
